import { onBeforeUnmount } from "vue";
import { useStore } from "vuex";

export function setupViewport() {
  const store = useStore();

  const update = () => {
    store.commit("updateViewportSize", window.innerWidth);
  };

  update();

  window.addEventListener("resize", update);

  onBeforeUnmount(() => window.removeEventListener("resize", update));
}
